const genericInputNullOption = {
  value: null, label: 'N/A'
}

const useStandardLineItemMetaOptions = function({ lineItem, subscription, rates, newMode, inputId, allowMetadataEditing }) {
  
  const selectedStartDateValue = lineItem.fields.parker.value?.fields.selected_start_date.value;
  const selectedStartDateKey = (selectedStartDateValue) ?
    `${inputId}--selected-start-date--${selectedStartDateValue.getUTCFullYear()}-${(selectedStartDateValue.getUTCMonth() + 1).toString().padStart(2, '0')}-${selectedStartDateValue.getUTCDate().toString().padStart(2, '0')}` :
    `${inputId}--selected-start-date--0000-00-00`;
  const selectedEndDateValue = lineItem.fields.parker.value?.fields.selected_end_date.value;
  const selectedEndDateKey = (selectedEndDateValue) ?
    `${inputId}--selected-end-date--${selectedEndDateValue.getUTCFullYear()}-${(selectedEndDateValue.getUTCMonth() + 1).toString().padStart(2, '0')}-${selectedEndDateValue.getUTCDate().toString().padStart(2, '0')}` :
    `${inputId}--selected-end-date--0000-00-00`;

  const parkerInputOptions = [ genericInputNullOption ];
  if (newMode && subscription) {
    subscription.fields.parkers.value.forEach(parker => {
      parkerInputOptions.push({
        value: parker.fields.id.value,
        label: [
          parker.fields.first_name.value || '',
          parker.fields.last_name.value || ''
        ].join(' ').trim()
      });
    });
  }
  else if (allowMetadataEditing && lineItem.fields.parker.value) {
    parkerInputOptions.push({
      value: lineItem.fields.parker.value.fields.id.value,
      label: [
        lineItem.fields.parker.value.fields.first_name.value || '',
        lineItem.fields.parker.value.fields.last_name.value || ''
      ].join(' ').trim()
    });
  }

  const rateInputOptions = [];
  if (newMode) {
    rates.forEach(rate => {
      rateInputOptions.push({
        value: rate.fields.id.value,
        label: rate.fields.name.value
      });
    });
  }
  else if (!allowMetadataEditing) {
    rateInputOptions.push(genericInputNullOption)
  }
  else {
    if (lineItem.fields.rate.value) {
      rateInputOptions.push({
        value: lineItem.fields.rate.value.fields.id.value,
        label: lineItem.fields.rate.value.fields.name.value
      });
    }
  }

  const feeInputOptions = [{
    value: null, label: 'N/A'
  }];
  if (newMode && lineItem.fields.rate.value && lineItem.fields.rate.value.fields.id.value !== null) {
    const rate = rates.find(rate => {
      return rate.fields.id.value === lineItem.fields.rate.value.fields.id.value;
    });
    if (rate) {
      rate.allFees.forEach(fee => {
        feeInputOptions.push({
          value: fee.fields.id.value,
          label: fee.fields.display_name.value
        });
      });
    }
  }
  else {
    if (lineItem.fields.fee.value) {
      feeInputOptions.push({
        value: lineItem.fields.fee.value.fields.type.value,
        label: lineItem.fields.fee.value.fields.type.value
      });
    }
  }

  return {
    parkerInputOptions,
    rateInputOptions,
    feeInputOptions,
    selectedStartDateKey,
    selectedEndDateKey
  }
}

export default useStandardLineItemMetaOptions;